// Shared constants for product card styling
// Update these values to change all cards site-wide

export const CARD_HEIGHT = '420px';

// Gradient extends beyond content area to create smooth fade
export const CARD_OVERLAY_GRADIENT = 'linear-gradient(to top, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.9) 30%, rgba(255,255,255,0.7) 60%, rgba(255,255,255,0.4) 80%, rgba(255,255,255,0) 100%)';

export const CARD_SHADOW = '0 4px 20px rgba(0,0,0,0.08)';

export const CARD_BORDER_RADIUS = 'rounded-2xl';

export const CARD_BACKDROP_BLUR = 'backdrop-blur-sm';
